import React from 'react';
import styled from 'styled-components';
import { Progress as SuiProgress, ProgressProps as SuiProgressProps } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
// import { lighten, modularScale } from 'polished';

const Progress = ({ primary, secondary, value, total, ...rest }: ProgressProps) => {
	const barColor = useSelector(state => { return primary ? state.ui.customer.primaryColor : secondary ? state.ui.customer.secondaryColor : null; });
	const finalBarColor = (value as number) === (total as number) ? '#909090' : (value as number) > (total as number) ? '#ff0000' : barColor;

	return (
		<StyledProgress barColor={finalBarColor} value={value} total={total} { ...rest } />
	);
};

const MiddleManProgress = ({ barColor, ...rest }: MiddleManProgressProps) => {
	return (
		<SuiProgress { ...rest } />
	);
};

const StyledProgress = styled(MiddleManProgress)`
	${(p: MiddleManProgressProps) => `
		${(p.barColor !== undefined && p.barColor !== null) && `
			&&& .bar {
				background: ${p.barColor};
			}
		`}
	`}
`;

interface ProgressProps extends SuiProgressProps {
	primary?: boolean;
	secondary?: boolean;
}

interface MiddleManProgressProps extends SuiProgressProps {
	barColor?: string;
}

export default Progress;